import type { LayoutFrameMode } from "@tc-superpods/app-contract";
import { type JSX, type ReactNode, type RefObject } from "react";
import type { DialogController } from "../dialog-controller";
import type { DialogView } from "../types";
import { DialogLayer } from "./DialogLayer";

export interface ContentAreaProps {
  title: string | null;
  /**
   * Whether to render the platform top bar (`kn-content-topbar`). The shell
   * defaults to a clean, top-bar-free layout; an app opts in via its registry
   * entry's `showTopbar` flag. The sidebar owns the collapse trigger regardless,
   * so a hidden top bar never removes navigation controls.
   */
  showTopbar: boolean;
  /** In `app` mode the app owns the frame: the top bar is not rendered and `showTopbar` is ignored. */
  frame: LayoutFrameMode;
  outletRef: RefObject<HTMLElement>;
  dialogs: DialogView[];
  dialogController: DialogController;
  children?: ReactNode;
}

export function ContentArea({
  title,
  showTopbar,
  frame,
  outletRef,
  dialogs,
  dialogController,
  children
}: ContentAreaProps): JSX.Element {
  return (
    <div data-platform-layout="" data-platform-frame={frame} data-topbar={showTopbar && frame === "shell" ? "" : undefined}>
      {showTopbar && frame === "shell" && title ? (
        <div className="kn-content-topbar">
          <div className="kn-content-topbar-heading">
            <h1 className="kn-content-topbar-title">{title}</h1>
          </div>
        </div>
      ) : null}
      <div className="kn-outlet-wrapper">
        {children ? (
          <div data-platform-local-content="" data-platform-shell-scroll="">
            {children}
          </div>
        ) : null}
        <main
          data-platform-outlet=""
          data-platform-shell-scroll=""
          ref={outletRef}
          hidden={children !== undefined}
        />
        <DialogLayer dialogs={dialogs} controller={dialogController} />
      </div>
    </div>
  );
}
